import { useMutation, useQueryClient } from '@tanstack/react-query';

import { patchVenueMarketing, type VenueMarketingPatch } from '../../../../api/venue-marketing';
import { venueKey } from '../useVenue';

import { isAccessRefusal } from './venue-marketing-errors';

/** Saves marketing details and puts the fresh venue straight into the cache,
 *  so the page re-renders from what the server now holds. A venue fetch that
 *  was already in flight is cancelled first so it cannot land on top of the
 *  save. After a 403 or 404 the venue is reloaded, since what the caller may
 *  do (or whether the venue exists) has changed. */
export function useUpdateVenueMarketing(venueId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: VenueMarketingPatch) => patchVenueMarketing(venueId, patch),
    onMutate: async () => {
      await qc.cancelQueries({ queryKey: venueKey(venueId) });
    },
    onSuccess: (venue) => {
      qc.setQueryData(venueKey(venueId), venue);
    },
    onError: (err) => {
      if (isAccessRefusal(err)) void qc.invalidateQueries({ queryKey: venueKey(venueId) });
    },
  });
}
